import React, { useEffect, useState } from "react";
import "./MaintenancePage.css";

export default function MaintenancePage() {
  const [darkMode, setDarkMode] = useState(true);

  useEffect(() => {
    setDarkMode(true);
    document.body.className = darkMode ? "dark" : "light";

    return () => {
      document.body.className = "";
    };
  }, [darkMode]);

  return (
    <main
      className={`maintenance-container ${darkMode ? "dark" : "light"}`}
      aria-labelledby="maintenance-title"
    >
      <div className="maintenance-card">
        <div className="logo-crop">
          <img
            src="/logo.png"
            alt="Pasla futbol organizasyon platformu logosu"
            className="maintenance-logo"
          />
        </div>

        <p className="maintenance-badge">Çok Yakında</p>

        <h1 id="maintenance-title" className="maintenance-title">
          Sahaya dönüş başlıyor.
        </h1>

        <p className="maintenance-description">
          Pasla, futbol oynayanları ve takım arayanları aynı platformda
          buluşturmak için hazırlanıyor. Daha hızlı, daha kolay ve daha doğru
          eşleşmeler için çok yakında yayındayız.
        </p>

        <section className="feature-list" aria-label="Pasla platform özellikleri">
          <article className="feature-item">
            <h2>Oyuncu Bul</h2>
            <p>Takımının ihtiyacına uygun oyuncularla kısa sürede eşleş.</p>
          </article>

          <article className="feature-item">
            <h2>Maç Bul</h2>
            <p>Yakınındaki maçları keşfet, sana uygun karşılaşmalara katıl.</p>
          </article>

          <article className="feature-item">
            <h2>Rakip Bul</h2>
            <p>Takım seviyene uygun rakiplerle maç organize et.</p>
          </article>
        </section>

        <p className="maintenance-footer">
          <strong>Pasla ile maç organize etmek artık çok daha kolay.</strong>
        </p>
      </div>
    </main>
  );
}
